import { ETimeUnit } from '@hooks'
import { SearchFilterValue } from '@types'
import { SearchFilterForm } from '../AddSimpleFilterDialog'

export const getDefaultValues = (): SearchFilterForm => {
  return {
    id: '',
    code: '',
    title: '',
    objectTitle: '',
    isPinning: false,
    value: {
      name: null,
      fieldType: null,
      formatDate: null,
      objectValue: '',
      linkedObjectCode: '',
      isDefaultPlaceholder: true,
      placeholderValue: '',
      placeholderEnd: '',
      placeholderStart: '',
      isPinning: false,
      dropDownListCode: null,
      dropDownWindowCode: null,
      dropDownListFilters: [],
      dropDownWindowFilters: [],
      isGroupRelated: false,
      asCheckbox: false,
      asDuration: false,
      pathArray: [],
      min: -24,
      max: 48,
      timeUnit: { id: ETimeUnit.HOUR, label: ETimeUnit.HOUR },
      isFilterByObject: false,
    },
    object: null,
    visibility: true,
  }
}
